// ADDED
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

const SalaryAdvanceAccessAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [accessType, setAccessType] = useState(""); // "assignment", "releasing", or ""

  useEffect(() => {
    if (isOpen && selectedItem) {
      if (selectedItem.isSalaryAdvanceAssignmentManager) {
        setAccessType("assignment");
      } else if (selectedItem.isSalaryAdvanceReleasingManager) {
        setAccessType("releasing");
      } else {
        setAccessType("");
      }
    }
  }, [selectedItem, isOpen]);

  const handleAccessTypeChange = (event) => {
    setAccessType(event.target.value);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 overflow-auto">
      <div className="bg-white w-full md:w-[500px] rounded-lg shadow-xl flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold text-gray-800">Update Salary Advance Access</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer text-gray-500 hover:text-gray-700 transition-colors">
            <CloseIcon fontSize="medium" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-6">
          {/* Access Type Description */}
          <div>
            <label className="block text-sm font-semibold text-gray-500 uppercase mb-2">Access Type Information</label>
            <input
              value={selectedItem?.description || ""}
              disabled
              className="w-full p-2 border border-gray-300 rounded bg-gray-100 text-gray-600 italic"
            />
          </div>

          {/* Radio Selection */}
          <div className="border border-gray-200 rounded-lg bg-gray-50 p-4">
            <h3 className="text-sm font-semibold mb-4 text-gray-700">Select Access Role</h3>
            <div className="flex flex-col gap-4">
              <label className="flex items-center space-x-3 cursor-pointer p-2 hover:bg-white rounded transition-all border border-transparent hover:border-gray-200">
                <input
                  type="radio"
                  name="salaryAccessType"
                  value="assignment"
                  checked={accessType === "assignment"}
                  onChange={handleAccessTypeChange}
                  className="h-4 w-4 text-blue-600"
                />
                <span className="text-gray-800 font-medium">Assignment Manager</span>
              </label>

              <label className="flex items-center space-x-3 cursor-pointer p-2 hover:bg-white rounded transition-all border border-transparent hover:border-gray-200">
                <input
                  type="radio"
                  name="salaryAccessType"
                  value="releasing"
                  checked={accessType === "releasing"}
                  onChange={handleAccessTypeChange}
                  className="h-4 w-4 text-blue-600"
                />
                <span className="text-gray-800 font-medium">Releasing Manager</span>
              </label>

              <label className="flex items-center space-x-3 cursor-pointer p-2 hover:bg-white rounded transition-all border border-transparent hover:border-gray-200">
                <input
                  type="radio"
                  name="salaryAccessType"
                  value=""
                  checked={accessType === ""}
                  onChange={handleAccessTypeChange}
                  className="h-4 w-4 text-blue-600"
                />
                <span className="text-gray-800 font-medium italic text-gray-500">None (No Access)</span>
              </label>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end space-x-2 p-5 border-t bg-gray-50 rounded-b-lg">
          <button 
            onClick={onClose} 
            className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded border-none cursor-pointer transition-colors font-medium"
          >
            Cancel
          </button>
          <button 
            onClick={() => onSave(accessType)} 
            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded border-none cursor-pointer transition-colors font-medium"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalaryAdvanceAccessAddEditModal;